// src/views/Pages/DataArchive/TransactionManager/useBankStatementPDF.ts
import { getJwt } from "src/auth";

const BASE_URL = process.env.NODE_ENV === "production" ? "https://www.docuclipper.com" : "http://localhost:8080";

const useBankStatementPDF = ({
  selectedDocumentId,
}) => {
  const jwt = getJwt();

  const pdfURL = selectedDocumentId && jwt
    ? `${BASE_URL}/api/v1/protected/document/${selectedDocumentId}/file.pdf?token=${jwt}#page=${1}&pagemode=none&toolbar=1`
    : "";

  return {
    pdfURL,
  };
};

export default useBankStatementPDF;